/**
 * ContractDrawerEditModeBanner public entry point.
 * View-only — the parent owns the visibility flag and cancel handler.
 * @module features/contracts/components/ContractDrawerEditModeBanner
 */
export { default } from "./ContractDrawerEditModeBannerView";
